import styled from 'styled-components';

const BaseBtn = styled.div`
    width: 100%;
    height: 64px;
    margin-bottom: 16px;

    > * {
        width: 100%;
    }
`;

export const GooglePayBtn = styled(BaseBtn)``;
export const ApplePayBtn = styled(BaseBtn)``;

export const LoaderContainer = styled.div`
    margin: 42px auto;
    display: flex;
    justify-content: center;
`;
